<script lang="ts">
    import {onMount} from "svelte";
    import ButtonView from "../../../../component/common/Button/ButtonView.svelte";
    import AppAccessTokenDialogView from "./AppAccessTokenDialogView.svelte";

    export let app;

    onMount(() => {
    });

    let isShowAccessTokenDialog = false;

    function onClickOpenAccessToken() {
        isShowAccessTokenDialog = true;
    }

</script>

<div class="app-manage-view">
    <fieldset>
        <legend>管理者設定</legend>
        <div class="app-manage-content">
            <div>
                <ButtonView on:click={onClickOpenAccessToken} text="アクセストークン設定を開く"/>

            </div>

        </div>

    </fieldset>


</div>


<AppAccessTokenDialogView
        app={app}
        isShow={isShowAccessTokenDialog}
        on:close={()=>{
            isShowAccessTokenDialog = false;
        }}
/>

<style lang="scss">
    .app-manage-view {

    }
</style>